import { Box, Button, CircularProgress, Typography } from "@mui/material";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";
import { formatCurrency } from "../../../utils/formatCurrency";
import saveNotAnswersLanding from "../../../Components/CluppForms/saveNotAnswersLanding";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const OfferDiscount = ({ state, setState }) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const handleAceptDiscount = async () => {
    setIsLoading(true);
    try {
      await saveNotAnswersLanding({
        landingId: state.currentLanding,
        state,
        sessionID: state.sessionID,
        prevForm: state.prevForm,
        metadata: {
          premium: state.premium,
          pid: state.pid,
          pType: state.pType,
          discount: state.discount,
          premiumWithDiscount: state.premiumWithDiscount,
        },
      });
      navigate(`/formulario/cancelacion/aceptar-descuento?uid=${state.userId}`);
    } catch (error) {
      console.log("[Error ACEPTING DISCOUNT]:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <TitleHeaders
        title={"¡No queremos que te vayas! Te ofrecemos un descuento especial."}
      />
      <Typography variant="body1">
        Queremos darte una razón más para que sigas con nosotros
        <span role="img" aria-label="pleading face">
          😉
        </span>
      </Typography>
      <Box
        sx={{
          mt: 3,
          mx: "auto",
          width: "90%",
          p: 1,
          borderRadius: "8px",
          backgroundColor: "#E3F2FD",
          textAlign: "center",
        }}
      >
        <Typography variant="h6">
          Actualmente pagas: {formatCurrency(state.premium)}.
        </Typography>
        <Typography variant="h6" sx={{ fontSize: "18px" }}>
          Te ofrecemos un descuento del:{" "}
          <span style={{ fontWeight: 700 }}>{state.discount}%</span>.
        </Typography>
        <br />
        <Typography variant="h6">
          Pasarías a pagar:{" "}
          <span style={{ fontWeight: 700 }}>
            {formatCurrency(state.premiumWithDiscount)}
          </span>{" "}
          de manera {state.period}.
        </Typography>
        <Typography variant="body1">
          Esto incluye las coberturas extras que tiene contratadas.
        </Typography>
      </Box>
      <Box sx={{ textAlign: "center" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleAceptDiscount}
          sx={{
            margin: "20px auto",
            textTransform: "none",
            fontSize: "18px",
            fontWeight: 600,
            width: "100%",
            borderRadius: "20px",
            textAlign: "center",
          }}
        >
          {isLoading ? (
            <CircularProgress sx={{ color: "#fff" }} />
          ) : (
            "Aceptar descuento 🤩"
          )}
        </Button>
      </Box>
    </>
  );
};

export default OfferDiscount;
